var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-message",class:[
        ("error-message--" + _vm.size + "-size"),
        {
            'error-message--shake': _vm.animating,
        } ],on:{"animationend":_vm.animationEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }